import React, { useState, useEffect, useRef } from 'react';

import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Service from './components/Service/Service';
import Tools from './components/Tools/Tools';
import Project from './components/Project/Project';
import Team from './components/Team/Team';
import Contact from './components/Contact/Contact';
import Form from './components/Form/Form';
import Footer from './components/Footer/Footer';
import GoToUp from './components/GoToUp/GoToUp';

const App = () => {
  const [navbarTransparent, setNavbarTransparent] = useState(false);
  const [currentMenu, setCurrentMenu] = useState(0);
  const scrollRef = useRef();
  const mostTopRef = useRef();
  const goToTopRef = useRef();
  const serviceRef = useRef();
  const projectRef = useRef();
  const contactRef = useRef();

  const goUp = () => {
    mostTopRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  useEffect(() => {
    const scrollEvent = scrollRef.current.addEventListener('scroll', (event) => {
      const scrollTop = event.target.scrollTop;
      const serviceScrollTop = serviceRef.current.offsetTop;
      const projectScrollTop = projectRef.current.offsetTop;
      const contactScrollTop = contactRef.current.offsetTop;

      if (scrollTop >= 64) {
        setNavbarTransparent(true);
        goToTopRef.current.classList.replace('translate-y-20', 'translate-y-0');
      } else {
        setNavbarTransparent(false);
        goToTopRef.current.classList.replace('translate-y-0', 'translate-y-20');
      }

      if ((scrollTop + 100) >= 100) {
        setCurrentMenu(0);
      }
      if ((scrollTop + 100) >= serviceScrollTop) {
        setCurrentMenu(1);
      }
      if ((scrollTop + 100) >= projectScrollTop) {
        setCurrentMenu(2);
      }
      if ((scrollTop + 100) >= contactScrollTop) {
        setCurrentMenu(3)
      }

    });

    return () => {
      window.removeEventListener('scroll', scrollEvent);
    }
  }, [])

  return (
    <div className="w-full h-screen overflow-y-scroll" ref={scrollRef}>
      <div ref={mostTopRef} />
      <Navbar
        navbarTransparent={navbarTransparent}
        currentMenu={currentMenu}
        setCurrentMenu={setCurrentMenu}
        sectionRefs={[mostTopRef, serviceRef, projectRef, contactRef]}
      />
      <Hero setCurrentMenu={setCurrentMenu} />
      <Service ref={serviceRef} />
      <Tools />
      <Project ref={projectRef} />
      <Team />
      <Contact ref={contactRef} />
      <Form />
      <Footer />
      <GoToUp ref={goToTopRef} goUp={goUp} />
    </div>
  )
};

export default App;
